import { render, staticRenderFns } from "./studentlist.vue?vue&type=template&id=0e617cfd&scoped=true"
import script from "./studentlist.vue?vue&type=script&lang=js"
export * from "./studentlist.vue?vue&type=script&lang=js"
import style0 from "./studentlist.vue?vue&type=style&index=0&id=0e617cfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e617cfd",
  null
  
)

export default component.exports